import { Action } from 'redux';
import { SupplierInfoModel } from '../../../api/core/core.types';

export const GET_SUPPLIER_INFO = 'GET_SUPPLIER_INFO';
export const PUT_SUPPLIER_INFO = 'PUT_SUPPLIER_INFO';

export interface GetSupplierInfoAction extends Action {
  type: typeof GET_SUPPLIER_INFO;
  payload: {
    supplierInfo: SupplierInfoModel | null;
  };
}

export interface PutSupplierAction extends Action {
  type: typeof PUT_SUPPLIER_INFO;
  payload: {
    selectedSupplierInfo: SupplierInfoModel;
  };
}

export interface SupplierInfoState {
  supplierInfo: SupplierInfoModel | null;
  selectedSupplierInfo: SupplierInfoModel | null;
  lastFetch: number | null;
  postSuccess: boolean | null
}

export type SupplierInfoActionTypes = GetSupplierInfoAction | PutSupplierAction;
